/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext } from "react";
import { CImage } from "@coreui/react";
import { StoreContext } from "../context/StoreContext";
import { useStoreStock } from "../context/StoreStockContext";

const Leftsidebar = (props) => {
  const {
    storeTypes,
    sidebarIcons,
    selectedStore,
    setSelectedStore,
    setSelectedSortOption,
    setDropdownOpen,
    setHasSearched,
    setPageNo,
  } = useContext(StoreContext);
  const { setShowStoreStock } = useStoreStock();

  return (
    <div
      className={
        props?.sidebarShow ? "left-sidebar--slide show" : "left-sidebar--slide"
      }
    >
      <div className="ezybuy-leftsidebar-fixed">
        <ul>
          <li
            className={`sidebar-select mobile-only-x sorting-dropdown-options-label ${
              selectedStore?.name === "All Stores" ? "active" : ""
            }`}
            onClick={() => {
              setSelectedStore({ name: "All Stores", storeTypeID: "" });
              setShowStoreStock(false);
              setSelectedSortOption({});
              setDropdownOpen(false);
              setHasSearched(false);
              setPageNo(1);
            }}
          >
            <span className="d-f a-c gap-15">
              <div className="option-all">All</div>
              All Stores
            </span>
          </li>

          {storeTypes.length > 0 &&
            storeTypes.map((el, index) => (
              <li
                key={el?.storeTypeID}
                className={`sidebar-select ${
                  selectedStore.name === el?.name ? "active" : ""
                }`}
                onClick={() => {
                  setSelectedStore({
                    name: el?.name,
                    storeTypeID: el?.storeTypeID,
                  });
                  setShowStoreStock(false);
                  setSelectedSortOption({});
                  setDropdownOpen(false);
                  setHasSearched(false);
                  setPageNo(1);
                }}
              >
                <div>
                  <CImage
                    className={`sidebar-icon ${
                      selectedStore.name === el?.name ? "active" : ""
                    }`}
                    src={
                      sidebarIcons[index]?.url ||
                      "/images/default-store-icon.svg"
                    }
                    alt="icon"
                  />
                </div>

                {el?.name}
              </li>
            ))}
        </ul>

        <span
          className="fixed-close-icon a-c j-c w-100"
          onClick={() => props?.setSidebarShow(false)}
          tabIndex={0}
          onKeyDown={(e) => e.preventDefault()}
          role="button"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 62 62"
            fill="none"
          >
            <circle cx="31" cy="31" r="31" fill="#058E72" fillOpacity="0.14" />
            <path
              d="M20 41L40.895 20ZM41 41L20.105 20Z"
              fill="#058E72"
              fillOpacity="0.14"
            />
            <path
              d="M20 41L40.895 20M41 41L20.105 20"
              stroke="#058E72"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </div>
    </div>
  );
};

export default Leftsidebar;
